<template>
  <div class="activity-main-root">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.webp" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules02.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="activity-con" :style="{ 'margin-top': `-${topBarHeight + 46}px` }">
      <div class="activity-head" :style="{ 'padding-top': `${topBarHeight + 46 + 5}px` }">
        <div class="head-title">
          <MyPLabel class="head-title-txt head-title-txt1" :str="$t('lang.EidAlAdha.k003')" :customClass="{ coin: 'act-eidaladha-bean' }" />
          <div class="head-title-txt head-title-txt2">{{ $t('lang.EidAlAdha.k004') }}</div>
        </div>

        <div class="deal-tip">{{ $t('lang.EidAlFitr.k002') }}</div>
        <div class="deal-line">
          <div class="timer">
            <img src="./images/clock.webp" />
            <span class="time-num">
              <span>{{ countdownObj.countdownResult.days }}</span>
              <i>{{ $t('lang.ActCommon.k049') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownObj.countdownResult.hours }}</span>
              <i>{{ $t('lang.ActCommon.k060') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownObj.countdownResult.minutes }}</span>
              <i>{{ $t('lang.ActCommon.k061') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownObj.countdownResult.seconds }}</span>
              <i>{{ $t('lang.ActCommon.k062') }}</i>
            </span>
          </div>
        </div>

        <div class="head-empty"></div>
      </div>

      <div class="main-con">
        <div v-if="actInfo" class="points-rank">
          <div class="pr-item pr-item1">
            <div>{{ $t('lang.ActCommon.k020') }}</div>
            <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
            <img class="size1" src="./images/star.webp" />
          </div>
          <div class="pr-gap"></div>
          <div class="pr-item pr-item2">
            <div>{{ $t('lang.ActCommon.k021') }}</div>
            <div v-if="actInfo">{{ actInfo.rank || '--' }}</div>
            <img class="size2" src="./images/cup.webp" />
          </div>
        </div>

        <!-- 任务 -->
        <div class="part-block part-block1">
          <div class="part-head">
            <div>{{ $t('lang.ActCommon.k012') }}</div>
          </div>

          <div class="part-task task1">
            <MyPLabel class="part-task-tit" :str="$t('lang.EidAlFitr.k013')" :numsOption="[{ value: 60 }]" />
            <div class="part-task-reward">+1 {{ $t('lang.EidAlFitr.k015') }}</div>
            <div class="part-task-btn" @click="appAction('open_match_page')">{{ $t('lang.EidAlFitr.k029') }}</div>
          </div>

          <div class="part-task task2">
            <MyPLabel class="part-task-tit" :str="$t('lang.EidAlFitr.k014')" :numsOption="[{ value: 60 }]" />
            <div class="part-task-reward">+3 {{ $t('lang.EidAlFitr.k015') }}</div>
            <div class="part-task-btn" @click="appAction('open_session_page')">{{ $t('lang.EidAlFitr.k029') }}</div>
          </div>
        </div>

        <!-- 转盘 -->
        <div class="part-block part-block4">
          <div class="part-head">
            <div>{{ $t('lang.EidAlFitr.k017') }}</div>
          </div>
          <div class="part-wheel">
            <div class="switch-wheel">
              <div class="wheel-item" :class="[controlWheel.isSwitch === 'silver' ? 'on' : 'off']" @click="handleSwitchWheel('silver')">
                {{ $t('lang.EidAlFitr.k018') }}
              </div>
              <div class="wheel-item" :class="[controlWheel.isSwitch === 'gold' ? 'on' : 'off']" @click="handleSwitchWheel('gold')">
                {{ $t('lang.EidAlFitr.k019') }}
              </div>
            </div>

            <div class="wheel-pan">
              <div class="outher">
                <div v-if="actInfo" ref="wapper" class="wapper">
                  <div class="part1">
                    <div v-if="panData && panData[0]" class="item one" :class="{ gotted: controlWheel.gotDrawId === panData[0].id }">
                      <div class="text">
                        <template v-if="panData[0].propType === 0">
                          <span class="text-tips">{{ panData[0].count }}</span>
                          <img v-if="panData[0].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[0].propType !== 10" :src="resolveMatchImg(panData[0].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                    <div v-if="panData && panData[1]" class="item two" :class="{ gotted: controlWheel.gotDrawId === panData[1].id }">
                      <div class="text">
                        <template v-if="panData[1].propType === 0">
                          <span class="text-tips">{{ panData[1].count }}</span>
                          <img v-if="panData[1].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[1].propType !== 10" :src="resolveMatchImg(panData[1].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                    <div v-if="panData && panData[2]" class="item three" :class="{ gotted: controlWheel.gotDrawId === panData[2].id }">
                      <div class="text">
                        <template v-if="panData[2].propType === 0">
                          <span class="text-tips">{{ panData[2].count }}</span>
                          <img v-if="panData[2].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[2].propType !== 10" :src="resolveMatchImg(panData[2].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                    <div v-if="panData && panData[3]" class="item four" :class="{ gotted: controlWheel.gotDrawId === panData[3].id }">
                      <div class="text">
                        <template v-if="panData[3].propType === 0">
                          <span class="text-tips">{{ panData[3].count }}</span>
                          <img v-if="panData[3].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[3].propType !== 10" :src="resolveMatchImg(panData[3].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="part2">
                    <div v-if="panData && panData[4]" class="item five" :class="{ gotted: controlWheel.gotDrawId === panData[4].id }">
                      <div class="text">
                        <template v-if="panData[4].propType === 0">
                          <span class="text-tips">{{ panData[4].count }}</span>
                          <img v-if="panData[4].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[4].propType !== 10" :src="resolveMatchImg(panData[4].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                    <div v-if="panData && panData[5]" class="item six" :class="{ gotted: controlWheel.gotDrawId === panData[5].id }">
                      <div class="text">
                        <template v-if="panData[5].propType === 0">
                          <span class="text-tips">{{ panData[5].count }}</span>
                          <img v-if="panData[5].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[5].propType !== 10" :src="resolveMatchImg(panData[5].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                    <div v-if="panData && panData[6]" class="item seven" :class="{ gotted: controlWheel.gotDrawId === panData[6].id }">
                      <div class="text">
                        <template v-if="panData[6].propType === 0">
                          <span class="text-tips">{{ panData[6].count }}</span>
                          <img v-if="panData[6].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[6].propType !== 10" :src="resolveMatchImg(panData[6].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                    <div v-if="panData && panData[7]" class="item eight" :class="{ gotted: controlWheel.gotDrawId === panData[7].id }">
                      <div class="text">
                        <template v-if="panData[7].propType === 0">
                          <span class="text-tips">{{ panData[7].count }}</span>
                          <img v-if="panData[7].count >= 200" :src="getMatchImg('coins')" />
                          <img v-else :src="getMatchImg('coin')" class="small-img" />
                        </template>
                        <template v-else>
                          <span class="text-tips"></span>
                          <img v-if="panData[7].propType !== 10" :src="resolveMatchImg(panData[7].propType)" />
                          <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wheel-pointer"></div>
            </div>

            <div class="spin-tips">
              <span>{{ $t('lang.EidAlFitr.k022') }}</span>
              &nbsp;
              <i>{{ controlWheel.restSpins || '0' }}</i>
            </div>

            <div class="spin-btn-con">
              <div class="spin-btn" :class="controlWheel.restSpins >= 1 ? 'on' : 'off'" @click="handleWheelPan(1)">
                {{ $t('lang.EidAlFitr.k020') }} x1
              </div>
              <div class="spin-gap"></div>
              <div class="spin-btn" :class="controlWheel.restSpins >= 10 ? 'on' : 'off'" @click="handleWheelPan(10)">
                {{ $t('lang.EidAlFitr.k020') }} x10
              </div>
            </div>

            <MyPLabel
              class="spin-tips wheel-tips"
              :str="$t('lang.EidAlFitr.k021')"
              :numsOption="[
                { value: controlWheel.costPoints, style: 'margin: 0 3px' },
                { value: 1, style: 'margin: 0 3px' },
              ]"
            />

            <div v-if="actInfo && actInfo.hasPrizeWheelRecord" class="spin-tips wheel-history" @click="handleToRecords">
              <img src="./images/history.webp" />
              {{ $t('lang.EidAlFitr.k009') }}
            </div>
          </div>
        </div>

        <!-- 排行 -->
        <div class="part-block part-block3">
          <div class="part-head">
            <div>{{ $t('lang.EidAlFitr.k003') }}</div>
            <div>{{ $t('lang.EidAlFitr.k004') }}</div>
          </div>
          <div class="part-rewards">
            <div class="rewards-block">
              <div class="reward-block-head">
                <div class="reward-mark"></div>
                <span>{{ $t('lang.EidAlFitr.k005') }}&nbsp;</span>
                <span>{{ countdownObj.countdownResult.days }}{{ $t('lang.ActCommon.k049') }}&nbsp;</span>
                <span>{{ countdownObj.countdownResult.hours }}</span>
                <span>:</span>
                <span>{{ countdownObj.countdownResult.minutes }}</span>
                <span>:</span>
                <span>{{ countdownObj.countdownResult.seconds }}</span>
              </div>
              <div class="reward-block-con">
                <div class="reward-item">
                  <div class="reward-1st">{{ $t('lang.EidAlFitr.k006') }}</div>
                  <div>
                    <img :src="getMatchImg('coin')" />
                    <span>{{ boardData.num1Reward }}</span>
                  </div>
                </div>
                <div class="reward-gap"></div>
                <div class="reward-item">
                  <div class="reward-2nd">{{ $t('lang.EidAlFitr.k007') }}</div>
                  <div>
                    <img :src="getMatchImg('coin')" />
                    <span>{{ boardData.num2Reward }}</span>
                  </div>
                </div>
                <div class="reward-gap"></div>
                <div class="reward-item">
                  <div class="reward-3rd">{{ $t('lang.EidAlFitr.k008') }}</div>
                  <div>
                    <img :src="getMatchImg('coin')" />
                    <span>{{ boardData.num3Reward }}</span>
                  </div>
                </div>
                <div class="reward-gap"></div>
                <div class="reward-item">
                  <div class="reward-4th">4-10</div>
                  <div>
                    <img :src="getMatchImg('coin')" />
                    <span>{{ boardData.num4Reward }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="part-rank">
            <!-- 1-3 -->
            <div class="prize">
              <div class="two">
                <img class="rank_c2_avatar" :src="prize2.avatar | imgPath" alt="" />
                <div class="rank-sort">
                  <img src="./images/r-two.webp" />
                </div>
                <div class="item-num">
                  <span class="name">{{ prize2.nickname || '--' }}</span>
                  <span class="num">
                    {{ prize2.score || '--' }}
                    {{ $t('lang.ActCommon.k046') }}
                  </span>
                </div>
                <div class="rank-line"></div>
              </div>

              <div class="prize-gap"></div>

              <div class="one">
                <img class="crown" src="./images/crown.webp" />
                <img class="rank_c1_avatar" :src="prize1.avatar | imgPath" alt="" />
                <div class="rank-sort">
                  <img src="./images/r-one.webp" />
                </div>
                <div class="item-num">
                  <span class="name">{{ prize1.nickname || '--' }}</span>
                  <span class="num">
                    {{ prize1.score || '--' }}
                    {{ $t('lang.ActCommon.k046') }}
                  </span>
                </div>
                <div class="rank-line"></div>
              </div>

              <div class="prize-gap"></div>

              <div class="three">
                <img class="rank_c3_avatar" :src="prize3.avatar | imgPath" alt="" />
                <div class="rank-sort">
                  <img src="./images/r-three.webp" />
                </div>
                <div class="item-num">
                  <span class="name">{{ prize3.nickname || '--' }}</span>
                  <span class="num">
                    {{ prize3.score || '--' }}
                    {{ $t('lang.ActCommon.k046') }}
                  </span>
                </div>
                <div class="rank-line"></div>
              </div>
            </div>
          </div>

          <div class="btn-green">
            <div class="real-btn" @click="handleToRank">
              {{ $t('lang.EidAlFitr.k010') }}
              <img src="./images/arrow.webp" />
            </div>
          </div>
        </div>

        <!-- 弹框 -->
        <div v-if="showSuccess" class="act-mask">
          <div class="dia-bg">
            <div class="con-block">
              <div class="gifts-tit">
                <span>{{ $t('lang.EidAlFitr.k023') }}</span>
              </div>
              <div v-if="showSuccess === 1" class="gifts-reward1">
                <div v-for="reward in rewards" :key="reward.id">
                  <div class="img-wrap">
                    <img v-if="reward.propType !== 10" :src="resolveMatchImg(reward.propType)" alt="" />
                    <img v-else class="avatar-bar" src="./images/avatar-bar.webp" />
                  </div>
                  <div class="rewards-count">x{{ reward.count }}</div>
                </div>
              </div>

              <template v-if="showSuccess === 10">
                <div class="gifts-reward2" style="justify-content: space-around; margin-bottom: 0">
                  <div v-for="reward in rewards" :key="reward.id">
                    <div class="img-wrap">
                      <img v-if="reward.propType !== 10" :src="resolveMatchImg(reward.propType)" alt="" />
                      <img v-else class="avatar-bar" src="./images/avatar-bar.webp" />
                    </div>
                    <div class="rewards-count">x{{ reward.count }}</div>
                  </div>
                </div>
              </template>

              <div class="gifts-confirm" @click="showSuccess = 0">
                <div>{{ $t('lang.ActCommon.k100') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalActBaseInfo, normalActRank, normalActSpin } from './apidir/api.js'

import CountDownClass from '@/utils/count-down.js'
import scrollMixin from '@/hooks/scroll.mixin.js'

const avarageCoinsItem = (arr) => {
  if (Array.isArray(arr) && arr.length > 0) {
    // prettier-ignore
    try {
      let result = []
      const coinsItems = arr.filter((item) => item.propType === 0)
      const propsItems = arr.filter((item) => item.propType !== 0)

      let propItem = propsItems.shift()
      let coinItem = coinsItems.shift()
      while (propItem && coinItem) {
        result.push(propItem)
        result.push(coinItem)
        propItem = propsItems.shift()
        coinItem = coinsItems.shift()
      }

      if (propItem) result.push(propItem)
      if (coinItem) result.push(coinItem)

      if (coinsItems.length) {
        result = result.concat(coinsItems)
      }
      if (propsItems.length) {
        result = result.concat(propsItems)
      }

      return result
    } catch {
      return arr
    }
  }

  return []
}

const angles = [337.5, 292.5, 247.5, 202.5, 157.5, 112.5, 67.5, 22.5]

export default {
  mixins: [scrollMixin],
  data() {
    return {
      actInfo: null,
      countdownObj: null,
      packageName: '',
      // 转盘
      isWheeling: false,
      controlWheel: {
        isSwitch: 'silver',
        gotDrawId: null,
        costPoints: '',
        restSpins: 0,
      },
      panData: null,
      // 排行
      boardData: {
        num1Reward: 2000,
        num2Reward: 1200,
        num3Reward: 800,
        num4Reward: 100,
      },
      prize1: {},
      prize2: {},
      prize3: {},

      // gift records
      showSuccess: 0,
      rewards: [],
      giftRecordsAll: [],
      giftRecordsPage: 1,
      giftRecordsPageSize: 20,
      giftRecordsLoading: false,
      giftRecordsNoMore: true,

      // 其他
      loading: false,
    }
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/eidaladha-rules-male', query: { from: 'eidaladha-main-male' } })
    },
    handleToRank() {
      this.$router.push({ path: '/eidaladha-rank-male', query: { from: 'eidaladha-main-male' } })
    },
    handleReplaceToRank() {
      this.$router.replace({ path: '/eidaladha-rank-male' })
    },
    handleToRecords() {
      this.$router.push({ path: '/eidaladha-records-male', query: { from: 'eidaladha-main-male' } })
    },
    // 转盘
    handleSwitchWheel(type) {
      if (type === 'silver' && this.actInfo && this.actInfo.normalPrizeWheel) {
        this.controlWheel.costPoints = this.actInfo.normalPrizeWheel.costPoint || ''
        this.controlWheel.restSpins = this.actInfo.normalPrizeWheel.restSpins || 0
        this.panData = avarageCoinsItem(this.actInfo.normalPrizeWheel.rewards)
      }
      if (type === 'gold' && this.actInfo && this.actInfo.advancedPrizeWheel) {
        this.controlWheel.costPoints = this.actInfo.advancedPrizeWheel.costPoint
        this.controlWheel.restSpins = this.actInfo.advancedPrizeWheel.restSpins || 0
        this.panData = this.actInfo.advancedPrizeWheel.rewards || []
      }
      this.controlWheel.isSwitch = type
    },
    resolveMatchImg(propType) {
      if (this.propsMap[propType]) {
        return this.getMatchImg(this.propsMap[propType])
      }
      return ''
    },
    handleWheelPan(spinCount) {
      const canSpin = (spinCount === 1 && this.controlWheel.restSpins >= 1) || (spinCount === 10 && this.controlWheel.restSpins >= 10)
      if (!canSpin) {
        return
      }

      if (!this.isWheeling) {
        this.controlWheel.gotDrawId = null
        this.$nextTick(() => {
          const switchMap = {
            silver: 1,
            gold: 2,
          }
          if (this.isPosting) {
            return
          }
          this.isPosting = true
          normalActSpin({
            type: switchMap[this.controlWheel.isSwitch],
            count: spinCount,
          })
            .then((resData) => {
              if (resData && !resData.error) {
                // 刷新数据
                this.fetchBaseData(() => {
                  this.handleSwitchWheel(this.controlWheel.isSwitch)
                })

                if (Array.isArray(resData)) {
                  // 抽X1
                  if (resData.length === 1) {
                    this.resolveData(resData[0].id, () => {
                      this.controlWheel.gotDrawId = resData[0].id
                      this.rewards = resData
                      this.showSuccess = 1
                    })
                  }
                  // 抽X10
                  if (resData.length === 10) {
                    this.resolveData('x10', () => {
                      this.rewards = resData
                      this.showSuccess = 10
                    })
                  }
                }
              }
            })
            .finally(() => {
              this.isPosting = false
            })
        })
      }
    },
    resolveData(gotDrawId, cbFn) {
      if (gotDrawId === 'x10') {
        this.doWheelPan(0, cbFn, 20)
        return
      }

      const tempArr = this.panData || []
      const originIndex = tempArr.findIndex((item) => item.id === gotDrawId)
      if (originIndex > -1) {
        this.doWheelPan(angles[originIndex], cbFn, 100)
      }
    },
    doWheelPan(angle, fn, interval = 50) {
      this.isWheeling = true

      let begin = 0
      const basic = 1800

      const timer = setInterval(() => {
        if (begin > basic + angle) {
          this.isWheeling = false
          clearInterval(timer)
          fn && fn()
        }
        this.$refs.wapper.style.transform = 'rotate(' + begin + 'deg)'
        begin += Math.ceil(basic + angle - begin) * 0.1
      }, interval)
    },
    // 初始数据
    fetchBaseData(cbFn) {
      normalActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          this.actInfo = resData || null

          if (this.actInfo.countdown <= 0) {
            this.handleReplaceToRank()
            return
          }

          if (!this.actInfo) return
          // 初始化倒计时
          if (this.actInfo.endTimestamp) {
            if (this.countdownObj && this.countdownObj.animationFrameId) {
              cancelAnimationFrame(this.countdownObj.animationFrameId)
              this.countdownObj.animationFrameId = null
            }
            this.countdownObj.initCountDown(this.actInfo.endTimestamp, 'DHMS', true)
          }
          cbFn && cbFn()
        }
      })

      normalActRank().then((resData) => {
        if (resData && !resData.error) {
          // 排名数据
          if (resData.ranks && resData.ranks.length > 0) {
            // 前三名
            this.prize1 = resData.ranks[0] || {}
            this.prize2 = resData.ranks[1] || {}
            this.prize3 = resData.ranks[2] || {}
          }
        }
      })
    },
  },
  created() {
    this.countdownObj = new CountDownClass()
    this.fetchBaseData(() => {
      // 初始化switch
      this.handleSwitchWheel('silver')
    })
  },
  beforeDestroy() {
    if (this.countdownObj && this.countdownObj.animationFrameId) {
      cancelAnimationFrame(this.countdownObj.animationFrameId)
    }
  },
}
</script>

<style lang="less" scoped>
.activity-main-root {
  width: 100%;
  min-height: 100vh;
  background: #06391f;

  .nav-default {
    background: url(./images/main-bg.webp) top left / 100% auto no-repeat;
  }

  .nav-scrolling {
    background: #06391f;
  }

  .activity-con {
    position: relative;
    .activity-head {
      width: 100%;
      height: fit-content;
      font-size: 0;
      position: relative;
      background: url(./images/main-bg.webp) top left / 100% auto no-repeat;
      .head-title {
        width: 100%;
        padding: 0 20px;
        margin: 10px auto 0;

        .head-title-txt {
          color: #fee81e;
          text-align: center;
          text-shadow: 3px 2px 0 #ac4801, 1px 2px 0 #ac4901, 5px 3px 8px rgba(10, 10, 10, 0.73);
          font-family: 'Anton-Regular';
          font-weight: bold;
        }
        .head-title-txt1 {
          font-size: 32px;
          line-height: 48px;
        }
        .head-title-txt2 {
          font-size: 28px;
          line-height: 42px;
        }
      }

      .deal-line {
        width: 100%;
        margin: 40px auto 50px;
        display: flex;
        align-items: center;
        justify-content: center;

        .timer {
          min-width: 223px;
          height: 40px;
          padding: 0 24px;

          display: inline-flex;
          align-items: center;
          justify-content: center;

          border-radius: 20px;
          border: 1px solid #b47e11;
          background: linear-gradient(90deg, rgba(55, 143, 85, 0.8) 0%, rgba(19, 91, 54, 0.8) 100%);
          backdrop-filter: blur(1px);
          img {
            width: 32px;
            height: 32px;
            margin: 0 3px;
          }
          > span {
            background: linear-gradient(180deg, #fff6a2 0%, #fffcb4 50%, #cbb811 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-family: 'TikTok Sans';
            font-size: 18px;
            font-weight: 600;
            line-height: normal;

            display: flex;
            align-items: flex-end;
            i {
              background: linear-gradient(180deg, #fff6a2 0%, #fffcb4 50%, #cbb811 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              font-family: 'TikTok Sans';
              font-size: 16px;
              font-weight: 600;
              line-height: normal;
            }
          }
          .stp {
            padding: 0 2px;
          }
          .time-num {
            span {
              width: 24px;
              text-align: center;
            }
          }
        }
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -40px;

      .points-rank {
        width: 355px;
        margin: 10px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .pr-item {
          flex: 1;
          min-height: 66px;
          padding: 16px 16px 20px;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          position: relative;
          div:nth-child(1) {
            font-family: 'TikTokSans-Regular';
            font-weight: 400;
            font-size: 14px;
            color: rgba(224, 255, 200, 0.92);
          }
          div:nth-child(2) {
            margin-top: 4px;
            font-family: 'TikTokSans-Regular';
            font-weight: 700;
            font-size: 32px;
            color: #ffe522;
            line-height: 36px;
            max-width: calc(100% - 34px);
            word-wrap: break-word;
          }
          img {
            position: absolute;
            right: 5px;
            bottom: 0px;
          }
          img.size1 {
            width: 36px;
            height: 36px;
            bottom: 20px;
          }
          img.size2 {
            width: 40px;
            height: 59px;
            bottom: 9px;
          }
        }
        .pr-item1 {
          background: url(./images/item-point.webp) top left / 100% 100% no-repeat;
        }
        .pr-item2 {
          background: url(./images/item-rank.webp) top left / 100% 100% no-repeat;
        }
        .pr-gap {
          width: 16px;
        }
      }

      .part-block {
        width: 355px;
        margin: 16px auto 0;
        padding: 5px 0 18px;
        border-radius: 12px;
        .part-head {
          width: 355px;
          line-height: 23px;
          border-radius: 12px 12px 0px 0px;
          text-align: center;
          > div:nth-child(1) {
            color: #ffffff;
            font-family: 'TikTokSans-Regular';
            font-size: 17px;
            font-weight: bold;
          }
          > div:nth-child(2) {
            color: rgba(224, 255, 200, 0.92);
            font-family: 'TikTokSans-Regular';
            font-size: 14px;
            font-weight: 400;
          }
        }

        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: 'TikTokSans-Regular';
          font-size: 15px;
          color: rgba(224, 255, 200, 0.92);
          line-height: 22px;
          font-weight: normal;
        }

        .part-task {
          width: 311px;
          padding: 16px;
          margin: 0 auto 20px;
          position: relative;

          border-radius: 16px;
          border: 0.5px solid #fede86;
          background: linear-gradient(90deg, #378f55 0%, #135b36 100%);
          .part-task-tit {
            color: rgba(224, 255, 200, 0.92);
            font-family: 'TikTokSans-Regular';
            font-size: 14px;
            font-weight: 400;
            line-height: 18px;
          }
          .part-task-reward {
            color: #ffe522;
            font-family: 'TikTokSans-Regular';
            font-size: 12px;
            font-weight: 700;
            line-height: 16px;
          }
          .part-task-btn {
            position: absolute;
            top: 50%;
            right: 16px;

            transform: translateY(-50%);
            text-align: center;
            color: #052f19;

            font-family: 'TikTokSans-Regular';
            font-size: 15px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px;

            border-radius: 16px;
            background: linear-gradient(283deg, #feb814 -4.94%, #ffffa8 58.33%, #fac401 113.65%);
            box-shadow: 0 0 6px 0 rgba(8, 37, 1, 0.13);

            padding: 8px 20px;

            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .task1 {
          margin-top: 24px;
        }

        .task2 {
          margin-bottom: 0;
        }

        .part-wheel {
          margin-top: 26px;
          .switch-wheel {
            width: 238px;
            height: 46px;
            margin: auto;
            padding: 1px;
            border-radius: 12px;
            border: 0.5px solid #fede86;
            background: #052f19;
            display: flex;
            align-items: center;
            .wheel-item {
              flex: 1;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 11px;
              font-family: 'TikTokSans-Regular';
              font-size: 14px;
              &.on {
                background: linear-gradient(90deg, #378f55 0%, #3c9a62 50%, #135b36 100%);
                color: #ffe522;
                font-weight: 700;
              }
              &.off {
                background: #052f19;
                color: rgba(224, 255, 200, 0.92);
                font-weight: 400;
              }
            }
          }

          .spin-tips {
            margin-top: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            color: rgba(224, 255, 200, 0.92);
            text-align: center;
            font-family: 'TikTokSans-Regular';
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;

            i {
              color: rgba(255, 229, 34, 0.92);
              font-family: 'TikTokSans-Regular';
              font-size: 14px;
              font-weight: 900;
              line-height: 22px;
            }
          }

          .wheel-tips {
            font-size: 12px;
          }

          .wheel-history {
            img {
              width: 14px;
              margin: 0 4px;
            }
            color: rgba(255, 229, 34, 0.92);
            font-family: 'PingFangSC-Regular';
            font-size: 12px;
            font-weight: 400;
            line-height: 22px;
            text-decoration-line: underline;
          }

          .wheel-pan {
            width: 303px;
            height: 303px;
            margin: 20px auto 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url(./images/wheel-pan.webp) top left / 100% auto no-repeat;
            position: relative;

            .wheel-pointer {
              position: absolute;
              top: 50%;
              left: 50%;
              z-index: 99;
              margin-top: -30px;
              margin-left: -20px;
              width: 40px;
              height: 52px;
              background: url(./images/wheel-pointer.webp) top left / 100% auto no-repeat;
            }
          }

          .spin-btn-con {
            width: 323px;
            margin: 20px auto 0;
            display: flex;
            .spin-btn {
              flex: 1;

              padding: 17px 5px;
              display: flex;
              align-items: center;
              justify-content: center;

              font-family: 'TikTokSans-Regular';
              font-size: 18px;
              font-weight: 700;
              line-height: 16px;
              border-radius: 12px;

              &.on {
                color: #052f19;
                border: 1px solid #fede86;
                background: linear-gradient(270deg, #feb814 -22.42%, #ffffa8 50.93%, #fac401 115.07%);
                box-shadow: 0 -0.2px 0.5px 0 rgba(81, 43, 0, 0.05);
              }
              &.off {
                color: #ffffff;
                border: 1px solid #c3c2c1;
                background: linear-gradient(270deg, #8a8988 -22.42%, #d4d4d3 50.93%, #7f7e7c 115.07%);
                box-shadow: 0 -0.2px 0.5px 0 rgba(41, 41, 40, 0.05);
              }
            }
            .spin-gap {
              width: 16px;
            }
          }
        }

        .part-rewards {
          padding: 0 26px;
          margin-top: 15px;
          .rewards-block {
            display: flex;
            flex-direction: column;
            .reward-block-head {
              display: flex;
              align-items: center;
              padding: 3px 4px;
              border-radius: 12px 12px 0 0;
              background: rgba(0, 0, 0, 0.2);
              backdrop-filter: blur(3px);
              > div {
                width: 16px;
                height: 16px;
                margin: 0 8px;
                background: url(./images/reward-mark.webp) top left / 100% 100% no-repeat;
              }
              > span {
                color: rgba(224, 255, 200, 0.92);
                font-family: 'TikTokSans-Regular';
                font-size: 12px;
                font-weight: 400;
              }
            }
            .reward-block-con {
              margin-top: -2px;
              display: flex;
              align-items: center;
              padding: 12px 0;
              border-radius: 0 0 12px 12px;
              background: rgba(0, 0, 0, 0.2);
              backdrop-filter: blur(3px);
              .reward-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                > div:nth-child(1) {
                  text-align: center;
                  font-family: 'TikTokSans-Regular';
                  font-size: 12px;
                  font-weight: 500;
                }
                > div:nth-child(2) {
                  display: flex;
                  align-items: center;
                  > img {
                    width: 14px;
                    height: 14px;
                    margin: 0 2px;
                  }
                  > span {
                    color: #ffffff;
                    text-align: center;
                    font-family: 'TikTokSans-Regular';
                    font-size: 14px;
                    font-weight: 700;
                  }
                }

                .reward-1st {
                  color: #ffe522;
                }
                .reward-2nd {
                  color: #ecb35d;
                }
                .reward-3rd {
                  color: #fed7aa;
                }
                .reward-4th {
                  color: rgba(255, 255, 255, 0.5);
                }
              }
              .reward-gap {
                width: 5px;
                height: 36px;
                position: relative;
                &::after {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 50%;
                  width: 1px;
                  height: 100%;
                  background: rgba(255, 255, 255, 0.1);
                }
              }
            }
          }
        }

        .part-rank {
          margin-top: 10px;
          position: relative;
          margin-bottom: 12px;
          .prize {
            width: 100%;
            margin: 0 auto;
            padding: 0 28px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            .prize-gap {
              width: 11px;
            }
            .one,
            .two,
            .three {
              width: 90px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-end;

              .item-num {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .name {
                  font-family: 'TikTokSans-Regular';
                  color: #ffffff;

                  width: 100%;
                  overflow: hidden;
                  text-align: center;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .num {
                  display: flex;
                  align-items: center;
                  font-family: 'Poppins-Regular';
                  font-size: 12px;
                  text-align: center;
                  display: inline-flex;
                  align-items: center;
                }
              }
            }
            .one {
              padding: 0 0 15px;
              .crown {
                width: 36px;
                position: static;
                z-index: 2;
              }
              .rank_c1_avatar {
                width: 56px;
                height: 56px;
                margin-top: -10px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #ffe522;
              }
              .rank-sort {
                display: flex;
                width: 24px;
                margin-top: -10px;
                img {
                  width: 100%;
                }
              }
              .item-num {
                .name {
                  font-size: 16px;
                  font-weight: 700;
                }
                .num {
                  color: #ffd700;
                  font-weight: 700;
                }
              }
              .rank-line {
                width: 100%;
                height: 6px;
                margin-top: 10px;
                border-radius: 9999px;
                background: #ffd700;
                box-shadow: 0 0 10px 0 rgba(255, 215, 0, 0.3);
              }
            }
            .two {
              .rank_c2_avatar {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #b3700c;
              }
              .rank-sort {
                display: flex;
                width: 22px;
                margin-top: -10px;
                img {
                  width: 100%;
                }
              }
              .item-num {
                .name {
                  font-size: 14px;
                  font-weight: 400;
                }
                .num {
                  color: #ecb35d;
                  font-weight: 400;
                }
              }
              .rank-line {
                width: 100%;
                height: 4px;
                margin-top: 7px;
                border-radius: 9999px;
                background: #ecb35d;
              }
            }
            .three {
              .rank_c3_avatar {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #c0a585;
              }
              .rank-sort {
                display: flex;
                width: 22px;
                margin-top: -10px;
                img {
                  width: 100%;
                }
              }
              .item-num {
                .name {
                  font-size: 14px;
                  font-weight: 400;
                }
                .num {
                  color: #fed7aa;
                  font-weight: 400;
                }
              }
              .rank-line {
                width: 100%;
                height: 4px;
                margin-top: 7px;
                border-radius: 9999px;
                background: #fed7aa;
              }
            }
          }
        }
      }

      .part-block1 {
        .part-head {
          margin-top: 5px;
        }
        background: url(./images/block-bg1.webp) top left / 100% 100% no-repeat;
      }

      .part-block2 {
        background: url(./images/block-bg2.webp) top left / 100% 100% no-repeat;
      }

      .part-block3 {
        background: url(./images/block-bg3.webp) top left / 100% 100% no-repeat;
      }

      .part-block4 {
        background: url(./images/block-bg4.webp) top left / 100% 100% no-repeat;
      }

      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: 'TikTokSans-Regular';
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-default {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .real-btn {
          min-width: 275px;
          display: inline-block;
          padding: 10px 15px;
          border-radius: 12px;
          border: 1px solid #fede86;
          background: linear-gradient(270deg, #feb814 -22.42%, #ffffa8 50.93%, #fac401 115.07%);
          box-shadow: 0 -0.2px 0.5px 0 rgba(81, 43, 0, 0.05);
          font-family: 'TikTokSans-Regular';
          font-weight: 700;
          font-size: 20px;
          color: #052f19;
          line-height: 26px;
          text-align: center;
          &.btn-disable {
            border-radius: 12px;
            border: 1px solid #c3c2c1;
            background: linear-gradient(270deg, #8a8988 -22.42%, #d4d4d3 50.93%, #7f7e7c 115.07%);
            box-shadow: 0 -0.2px 0.5px 0 rgba(41, 41, 40, 0.05);
            color: #ffffff;
          }
        }
      }

      .btn-green {
        display: block;
        width: 100%;
        margin-top: 26px;
        text-align: center;
        .real-btn {
          width: 303px;
          display: inline-block;
          padding: 14px 5px;
          border-radius: 12px;
          border: 0.5px solid #fede86;
          background: linear-gradient(90deg, #378f55 0%, #3c9a62 50%, #135b36 100%);
          font-family: 'TikTokSans-Regular';
          font-weight: 700;
          font-size: 14px;
          color: #ffe522;
          line-height: 18px;
          text-align: center;
          img {
            width: 12px;
            vertical-align: middle;
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    overflow-y: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    .dia-con {
      width: 315px;
      padding: 30px 16px;
      border-radius: 16px;
      border: 1px solid #feca44;
      background: linear-gradient(90deg, #308f50 0%, #175435 100%);

      .reward-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 23px;
          margin: 0 4px;
        }

        span {
          font-family: 'TikTokSans-Regular';
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
        }
      }

      .dia-tips {
        margin-top: 16px;
        width: 100%;
        font-family: 'TikTokSans-Regular';
        font-size: 14px;
        color: #ffffff;
        line-height: 18px;
        text-align: center;
      }

      .dia-btn {
        width: 255px;
        line-height: 26px;
        margin: 20px auto 0;
        padding: 10px;
        border-radius: 26px;
        border: 1px solid #fede86;
        background: linear-gradient(270deg, #feb814 -22.42%, #ffffa8 50.93%, #fac401 115.07%);
        box-shadow: 0 -0.2px 0.5px 0 rgba(81, 43, 0, 0.05);
        font-family: 'TikTokSans-Regular';
        font-weight: 600;
        font-size: 20px;
        color: #052f19;
        text-align: center;
      }
    }
  }
}

// 转盘样式
.outher {
  width: 245px;
  height: 245px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;

  .wapper {
    width: 246px;
    height: 246px;
    border-radius: 50%;
    .part1 {
      position: absolute;
      width: 123px;
      height: 246px;
      right: 0;
      overflow: hidden;
      text-align: center;

      .text {
        position: absolute;
        top: 16px;
        left: 11%;
        transform: rotate(23deg);

        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: left center;
      }

      .item.one {
        background-color: #3a9a67;
        z-index: 1;
      }

      .item.two {
        background-color: #2b7b36;
        transform: rotate(45deg);
        z-index: 2;
      }

      .item.three {
        background-color: #3a9a67;
        transform: rotate(90deg);
        z-index: 3;
      }

      .item.four {
        background-color: #2b7b36;
        transform: rotate(135deg);
        z-index: 4;
      }
    }

    .part2 {
      position: absolute;
      width: 123px;
      height: 246px;
      left: 0;
      overflow: hidden;

      .text {
        position: absolute;
        top: 16px;
        left: 57%;
        transform: rotate(-24deg);

        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: right center;
      }

      .item.five {
        background-color: #3a9a67;
        transform: rotate(-135deg);
        z-index: 4;
      }

      .item.six {
        background-color: #2b7b36;
        transform: rotate(-90deg);
        z-index: 3;
      }

      .item.seven {
        background-color: #3a9a67;
        transform: rotate(-45deg);
        z-index: 2;
      }

      .item.eight {
        background-color: #2b7b36;
        z-index: 1;
      }
    }

    .part1,
    .part2 {
      .gotted {
        background-color: #0c361e !important;
        .text {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .text-tips {
            color: #ffffff !important;
          }
        }
      }
    }

    .text {
      font-size: 0;
      .text-tips {
        min-height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Inter-Tight';
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        color: #ffffff;
      }

      > img {
        width: 36px;
      }
      > img.avatar-bar {
        width: 30px;
      }
      > img.small-img {
        width: 34px;
      }
    }
  }
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.act-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dia-bg {
    width: 325px;
    border-radius: 16px;

    .con-block {
      width: 325px;
      padding-bottom: 30px;
      border-radius: 16px;
      background: radial-gradient(111.34% 106.46% at 13.49% 0%, rgba(214, 255, 252, 0.7) 0%, rgba(214, 255, 252, 0) 100%),
        linear-gradient(180deg, #fefbcf 0%, #baf1a8 89%, #7bb568 103.49%);

      .gifts-tit {
        background: url(./images/dialog-bg1.webp) left top / 100% auto no-repeat;
        padding: 25px 16px 21px;
        width: 100%;
        line-height: 20px;
        text-align: center;
        margin-bottom: 16px;

        span {
          color: #135b36;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 20px;
          font-style: normal;
          font-weight: 900;
          line-height: normal;
        }
      }

      .gifts-reward1 {
        width: 100%;
        padding: 12px 0;
        border-radius: 8px;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        & > div {
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img-wrap {
            width: 60px;
            height: 60px;
            padding: 5px;
            border-radius: 8px;
            background: linear-gradient(180deg, rgba(227, 248, 121, 0.9) 0%, rgba(183, 223, 156, 0.9) 100%);
            img {
              width: 100%;
            }
          }
          .rewards-count {
            font-family: 'TikTokSans-Regular';
            font-weight: bold;
            font-size: 15px;
            color: #136a31;
            line-height: 22px;
            font-style: italic;
            margin-top: 2px;
          }
        }
      }

      .gifts-reward2 {
        display: block;
        width: 275px;
        margin: auto;
        padding: 12px 0;
        border-radius: 8px;
        font-size: 0;

        & > div {
          width: 20%;
          margin-bottom: 15px;
          display: inline-block;
          text-align: center;
          .img-wrap {
            display: inline-block;
            width: 36px;
            height: 36px;
            padding: 5px;
            border-radius: 8px;
            background: linear-gradient(180deg, rgba(227, 248, 121, 0.9) 0%, rgba(183, 223, 156, 0.9) 100%);
            img {
              width: 100%;
            }
          }
          .rewards-count {
            font-family: 'TikTokSans-Regular';
            font-weight: bold;
            font-size: 12px;
            color: #136a31;
            line-height: 22px;
            font-style: italic;
            opacity: 0.9;
            margin-top: 2px;
          }
        }
      }

      .gifts-confirm {
        width: 255px;
        margin: 0 auto;
        margin-top: 28px;
        padding: 10px;
        border-radius: 30px;
        background: linear-gradient(90deg, #28c173 0%, #135b36 100%);

        color: #fff;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px;
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .activity-main-root .activity-con .main-con .part-block .points-rank .pr-item img {
    right: unset;
    left: 5px;
  }

  .activity-main-root {
    .activity-con {
      .main-con {
        .points-rank {
          .pr-item1 {
            img {
              right: unset;
              left: 5px;
            }
          }
          .pr-item2 {
            img {
              right: unset;
              left: 5px;
            }
          }
        }
        .part-block {
          .part-task {
            .part-task-btn {
              right: unset;
              left: 16px;
            }
          }
        }
      }
    }
  }
}
</style>

<style>
.act-eidaladha-bean {
  width: 36px;
  height: 36px;
}
</style>
